(function () {
  // Versión Simplificada y Estable para Móviles de Gama Media
  // Objetivo: Que el pedido NO se borre cuando el usuario va a WhatsApp y vuelve.
  
  const INACTIVITY_LIMIT = 60 * 60 * 1000; // 1 hora de margen de inactividad
  const now = Date.now();
  const lastActivity = localStorage.getItem("_last_activity");

  // Si ha pasado más de 1 hora de inactividad, limpiamos por seguridad
  // Solo lo hacemos si estamos en la raíz (inicio), para no interrumpir un pedido en curso
  if (lastActivity && (now - parseInt(lastActivity)) > INACTIVITY_LIMIT) {
    if (window.location.pathname === "/") {
       localStorage.clear();
    }
  }

  // Actualizamos la última actividad en cada carga/interacción
  localStorage.setItem("_last_activity", now.toString());

  // También podemos añadir un listener para actualizar el timestamp al tocar la pantalla
  window.addEventListener('touchstart', () => {
    localStorage.setItem("_last_activity", Date.now().toString());
  }, { passive: true });

})();
